import { PROJDASH } from "../_constants/actionConstants";

const dashInitialState = {
  personal: [], // Array of personal widgets
  project: {}, // Project widgets, normalized by projectId, then normalized by widgetType
  fetching: false,
  error: null
};

export const reducer = (state = dashInitialState, action) => {
  switch (action.type) {
    case PROJDASH.FETCH_WIDGET_APIDATA:
    case PROJDASH.LOAD_WIDGETS:
    case PROJDASH.UPDATE_WIDGET:
      return { ...state, fetching: true };

    case PROJDASH.FETCH_WIDGET_APIDATA_FULFILLED:
    case PROJDASH.FETCH_WIDGET_APIDATA_REJECTED:
    case PROJDASH.LOAD_WIDGETS_REJECTED:
      return { ...state, fetching: false };

    case PROJDASH.LOAD_WIDGETS_FULFILLED: {
      return {
        ...state,
        fetching: false,
        project: {
          ...state.project,
          [action.projectId]: { ...action.payload }
        }
      };
    }

    case PROJDASH.UPDATE_WIDGET_FULFILLED:
      return {
        ...state,
        project: {
          ...state.project,
          [action.projectId]: {
            ...state.project[action.projectId],
            [action.widget.widgetType]: action.widget
          }
        },
        fetching: false
      };

    default:
      return state;
  }
};
